
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';

const classNames = mergeStyleSets({
    root: {

    }
});

const IsknDataComboBox = ({isknDate, title, onChange}) => {

    const [value, setValue] = useState(isknDate);

    const isknData = useSelector(state => state.iskn.data);

    useEffect(() => {
        if (onChange) {
            onChange(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChangeItem = (event, option) => {
        setValue(option.key);
    }

    const getOptions = () => {

        let options = [
            ...isknData.map(item => {
                return {
                    key: item.date,
                    text: item.title
                };
            })
        ];

        return options;
    }

    return (
        <div className={classNames.root}>
            <Dropdown
                label={title || 'Datová sada ISKN'}
                placeholder="Vyberte požadovanou datovou sadu ISKN..."
                options={getOptions()}
                selectedKey={value}
                onChange={handleChangeItem}
            />
        </div>
    );
}

export default IsknDataComboBox;
